/* eslint-disable jsx-a11y/anchor-is-valid */
import {useEffect, useState} from 'react'
import {MenuComponent} from '../../../../../../../../_ePulse/assets/ts/components'
import {KTSVG} from '../../../../../../../../_ePulse/helpers'
import {Link, useNavigate} from 'react-router-dom'

import {checkPermission} from '../../../../../../../App'
import useLocalStorageFetch from '../../../../../../../../hooks/localStorageFetch'
import {useDispatch} from 'react-redux'
import {actionsUsers} from '../../../../../../../../setup/redux/rootReducer'

const ActionsCell = (props: any) => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  useEffect(() => {
    MenuComponent.reinitialization()
  }, [])

  const {role} = useLocalStorageFetch()



  const appointment = props.tableProps

  return (
    <div className='d-flex ms-5'>
      <div className='d-flex flex-row col '>
        <div className='d-flex flex-row align-items-center '>
              <span>{props.tableProps?.latestStatus}</span>
          {/* {!appointment.isPrescriptionSent
            ? checkPermission('storeClinicRxPrescriptionData') && (
                <button
                  onClick={() => {
                    dispatch(actionsUsers.updateSelectedPatient({}))
                    onHandleclick(appointment)
                    localStorage.setItem('todayRXEdit', 'NO')
                  }}
                  className='menu-link px-3 text-dark border-0 bg-white text-decoration-underline'
                >
                  <span>RX</span>
                </button>
              )
            : checkPermission('storeClinicRxPrescriptionData') && (
                <button
                  onClick={() => {
                    dispatch(actionsUsers.updateSelectedPatient({}))
                    onHandleclick(appointment)
                    localStorage.setItem('todayRXEdit', 'YES')
                  }}
                  className='menu-link px-3 text-dark border-0 bg-white text-decoration-underline'
                >
                  <KTSVG path='/media/ePulse/edit_icon.svg' className='m-0' />
                </button>
              )} */}
        </div>
      </div>
    </div>
  )
}

export {ActionsCell}
